/* eslint-disable @typescript-eslint/naming-convention */
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';

export interface MessageDialogAction {
  handler: () => void;
  label: string;
  classes?: string;
}

export interface RadioOption {
  label: string;
  value: any;
  checked: boolean;
}

@Component({
  selector: 'app-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.scss'],
})
export class MessageDialogComponent implements OnInit {
  @Input()
  header: string;

  @Input()
  messageText: string;

  @Input()
  messageDetails: Array<string|string[]>;

  @Input()
  actionLabel: string;

  @Input()
  actionClass: string;

  @Input()
  actionPayload: any;

  @Input()
  actions: MessageDialogAction[];

  @Input()
  radioOptions: RadioOption[] = []; // Array of radio options for the dialog

  @Output()
  actionEvent = new EventEmitter<ActionEvent>();

  @Output()
  radioResponse = new EventEmitter<number>();

  @ViewChild('messageDialogModal', { static: true })
  public messageDialogModal: ModalDirective;

  selectedRadioValue: any = 0;

  constructor() {}

  ngOnInit() {

  }

  /**
   * messageText can be supplied statically using the @Input variable, or dynamically through the start() method.
   */
  start(messageText?: string, actionPayload?: any) {
    if (messageText) {
      this.messageText = messageText;
    }
    this.actionPayload = actionPayload;
    this.messageDialogModal.show();
  }

  isArray(thing: any) {
    return Array.isArray(thing);
  }

  show() {
    this.messageDialogModal.show();
  }

  hide() {
    this.messageDialogModal.hide();
  }

  onCancel() {
    this.actionEvent.emit(
      new ActionEvent(ActionState.CANCELLED, this.actionPayload)
    );
    this.messageDialogModal.hide();
  }

  onAction() {
    // send event...
    this.actionEvent.emit(
      new ActionEvent(ActionState.CONFIRMED, this.actionPayload, (this.radioOptions.length > 0) ? this.selectedRadioValue : null)
    );
    this.messageDialogModal.hide();
  }

  onRadioChange(selectedValue: any) {
    this.selectedRadioValue = selectedValue;
  }

}

export class ActionEvent {
  constructor(public state: ActionState, public payload: any, public selectedRadio?) {}
}

export enum ActionState {
  CANCELLED,
  CONFIRMED,
}
